// @ts-nocheck
import React, { createContext, useContext, useMemo, useState } from "react";

const FilterContext = createContext();

const FilterProvider = ({ children }) => {
	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const [searching, setSearching] = useState("");
	const [siteSelected, setSiteSelected] = useState(null);
	const [categoriesSelected, setCategoriesSelected] = useState(null);
	const [categoryIdsArray, setCategoryIdsArray] = useState([]);
	const [numberFilterActivated, setNumberFilterActivated] = useState(0);

	const value = useMemo(
		() => ({
			isFilterOpen,
			setIsFilterOpen,
			searching,
			setSearching,
			siteSelected,
			setSiteSelected,
			categoriesSelected,
			setCategoriesSelected,
			categoryIdsArray,
			setCategoryIdsArray,
			numberFilterActivated,
			setNumberFilterActivated,
		}),
		[
			isFilterOpen,
			searching,
			siteSelected,
			categoriesSelected,
			categoryIdsArray,
			numberFilterActivated,
		]
	);

	return (
		<FilterContext.Provider value={value}>
			{children}
		</FilterContext.Provider>
	);
};

export function useFilterContext() {
	return useContext(FilterContext);
}

export { FilterContext, FilterProvider };
